/* @flow */

import * as React from 'react';

import classnames from 'classnames';

export type StackSpacing = 0 | 2 | 4 | 6 | 8 | 12 | 16 | 20 | 24 | 32 | 36 | 48;

type Props = {
    children: React.Node,
    spacing?: StackSpacing,
    isHorizontal?: boolean,
    alignCenter?: boolean,
    justifyContent?: 'space-between' | 'center' | 'start' | 'end',
    // Expands the stack horizontally, only to be used with horizontal stacks (i.e. isHorizontal=true)
    isFullWidth?: boolean,
    isFullHeight?: boolean,
};

/**
 * @deprecated Use Stack instead
 */
export function StackLegacy(props: Props) {
    const className = classnames('flex', {
        'flex-dir-col': !props.isHorizontal,
        'align-center': props.alignCenter,
        'full-width': props.isFullWidth,
        'full-height': props.isFullHeight,
        'justify-sb': props.justifyContent === 'space-between',
        'justify-center': props.justifyContent === 'center',
        'justify-end': props.justifyContent === 'end',
        'justify-start': props.justifyContent === 'start',
    });

    return (
        <div className={className}>
            {React.Children.toArray(props.children)
                .filter((child) => child)
                .map((child, index) => {
                    const spacing = props.spacing
                        ? getSpacing(props.spacing, props.isHorizontal, index)
                        : {};

                    return (
                        <div
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            style={{...spacing}}
                        >
                            {child}
                        </div>
                    );
                })}
        </div>
    );
}

function getSpacing(spacing: StackSpacing, isHorizontal?: boolean, index: number): Object {
    const key = isHorizontal ? 'marginLeft' : 'marginTop';
    const value = index === 0 ? '0px' : `${spacing}px`;

    return {[key]: value};
}
